import { ImportacaoDeNota } from '@/models/ImportacaoDeNota'
import { Inject } from 'inversify-props'
import { ImportacaoDeNotaServiceAdapter } from './adapter'

export class FinalizarImportacaoDeNotaDoFornecedorUseCase {
	@Inject('ImportacaoDeNotaServiceAdapter')
	private importacaoDeNotaServiceAdapter!: ImportacaoDeNotaServiceAdapter

	async execute(importacaoDeNota: ImportacaoDeNota): Promise<ImportacaoDeNota> {
		return await this.importacaoDeNotaServiceAdapter.finalizarImportacao(importacaoDeNota)
	}
}